import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import { Button, CloseButton, Flex } from '../primitives';
import { createSavedSearch } from '../../BackendAPI';
import { getUser } from '../../utils/Auth2';

const FormContainer = styled.div`
  .form-group {
    margin-bottom: 20px;
  }

  .form-label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #333;
  }

  .form-input {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;

    &:focus {
      outline: none;
      border-color: #2579a9;
      box-shadow: 0 0 0 2px rgba(37, 121, 169, 0.2);
    }
  }

  .error-message {
    color: #dc3545;
    font-size: 12px;
    margin-top: 4px;
  }
`;

const SaveSearchModal = ({ showModal, onClose }) => {
  const [label, setLabel] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const currentUser = getUser();
  const currentSearchUrl = window.location.href;

  const handleSave = async () => {
    if (!label.trim()) {
      setError('Label is required');
      return;
    }

    try {
      setSaving(true);
      setError('');

      await createSavedSearch(
        currentUser?.user_id,
        currentUser?.first_name || currentUser?.email,
        currentSearchUrl,
        label.trim(),
      );

      setLabel('');
      onClose();
    } catch (err) {
      setError('Failed to save search. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  const handleClose = () => {
    setLabel('');
    setError('');
    setSaving(false);
    onClose();
  };

  const handleLabelChange = (e) => {
    setLabel(e.target.value);
    if (error) setError('');
  };

  const isSaveDisabled = !label.trim() || saving;

  return (
    <Modal backdrop="static" show={showModal} onHide={handleClose} className="tv-modal">
      <Modal.Header>
        <Modal.Title>Save Search</Modal.Title>
        <CloseButton className="modal-close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body>
        <FormContainer>
          <div className="form-group">
            <label className="form-label">
              Label<sup>*</sup>
            </label>
            <input
              type="text"
              className="form-input"
              value={label}
              onChange={handleLabelChange}
              placeholder="Enter a label for this search"
              disabled={saving}
            />
            {error && <div className="error-message">{error}</div>}
          </div>
        </FormContainer>
      </Modal.Body>
      <Modal.Footer>
        <Flex justify="space-between" fill>
          <Button onClick={handleClose} disabled={saving}>
            Cancel
          </Button>
          <Button onClick={handleSave} disabled={isSaveDisabled}>
            {saving ? 'Saving...' : 'Save'}
          </Button>
        </Flex>
      </Modal.Footer>
    </Modal>
  );
};

export default SaveSearchModal;
